import styled from '@emotion/styled';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';

/** 存在被当前套餐限制的站点/平台时展示的说明 */
export const AuthScopeHint = () => {
  const { t } = useTranslate();

  return (
    <Hint>
      <InfoCircleOutlined className="mr-[4px]" />
      {t('当前方案不支持此平台或站点，请选择可授权站点。')}
    </Hint>
  );
};

const Hint = styled.div`
  margin-bottom: 8px;
  font-size: 12px;
  color: var(--fett-text-secondary);
`;
